import React, { PropsWithChildren, useEffect } from "react";
import { Box } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import { autorun } from "mobx";
import { BoxProps } from "@material-ui/core/Box/Box";
import { CoreStoreInstance } from "../../Stores";

type AutoGridProps = {
    mobileArea?: string;
    ma?: string;
    tabletArea?: string;
    ta?: string;
    desktopArea?: string;
    da?: string;
    children?: any;
    desktopSpan?: number;
    ds?: number;
    tabletSpan?: number;
    ts?: number;
    mobileSpan?: number;
    ms?: number;
    onClick?: any;
} & PropsWithChildren<BoxProps>;
export const Cell: React.FC<AutoGridProps> = (props: AutoGridProps) => {
    const [area, setArea] = React.useState<string>(props.desktopArea!);
    const [span, setSpan] = React.useState<number>(props.desktopSpan!);
    const [view, setView] = React.useState("desktop");
    let { desktopArea, tabletArea, mobileArea, desktopSpan, tabletSpan, mobileSpan, ...boxProps } = props;

    useEffect(() => {
        desktopArea = desktopArea ?? props.da;
        tabletArea = tabletArea ?? props.ta;
        mobileArea = mobileArea ?? props.ma;
        desktopSpan = desktopSpan ?? props.ds;
        tabletSpan = tabletSpan ?? props.ts;
        mobileSpan = mobileSpan ?? props.ms;

        autorun(() => {
            //	console.log(StoresInstance.domain.screenWidth);
            if (CoreStoreInstance.isMobile) {
                setArea(mobileArea!);
                setSpan(mobileSpan!);
                setView("mobile");
            } else if (CoreStoreInstance.isTablet) {
                setArea(tabletArea!);
                setSpan(tabletSpan!);
                setView("tablet");
            } else if (CoreStoreInstance.isDesktop) {
                setArea(desktopArea!);
                setSpan(desktopSpan!);
                setView("desktop");
            }
        });
    }, []);

    return useObserver(() => (
        <>
            <Box {...boxProps} onClick={props.onClick ?? undefined} gridArea={area} gridColumn={`span ${span}`}>
                {props.children}
            </Box>
        </>
    ));
};
Cell.defaultProps = {
    justifyContent: "normal",
    alignContent: "normal",
};
